/* eslint-disable react/no-danger */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import AWS from 'aws-sdk';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import { FormattedMessage } from 'react-intl';
import { Col, Card, CardTitle, Row, CardBody } from 'reactstrap';
import moment from 'utils/moment';
import WeatherIcon from '../../../../icons/airfield-icons/weather.PNG';
import styles from './weather.module.scss';
import { saveWeatherData } from '../redux/actions';
import Spinner from '../../../../components/spinner';
import Clickable from '../../../../components/clickable/Clickable';

const Weather = ({ actionSaveWeather, weather,
  handelFullScreen,
  fullScreenMode, Metrics }) => {
  const [loading, setLoading] = useState(false);
  const [noWeatherData, setNoWeatherData] = useState(false);
  const [timeDiff, setTimeDiff] = useState(0);
  const urlParams = useParams();

  useEffect(() => {
    if (!weather.summary && timeDiff !== 5) {
      setLoading(true);
      const today = moment().utc();
      const year = today.year();
      const month = today.month();
      const date = today.date();
      const hour = today.hour();
      const docClient = new AWS.DynamoDB.DocumentClient();
      const params = {
        TableName: `${process.env.REACT_APP_MAIN_PREFIX}weather`,
        Key: { id: `${urlParams.airportCode.toUpperCase()}_${year}_${month + 1}_${date}_${hour - timeDiff}` }
      };
      docClient.get(params).promise().then((data) => {
        if (!data.Item) {
          const diff = timeDiff + 1;
          setLoading(false);
          setTimeDiff(diff);
          if (timeDiff === 4) {
            setNoWeatherData(true);
          }
        } else {
          setTimeDiff(5);
          actionSaveWeather(data.Item.metar);
          setLoading(false);
          setNoWeatherData(false);
        }
      }).catch((err) => {
        console.log(err);
        setLoading(false);
        setNoWeatherData(false);
      });
    }
  }, [urlParams.airportCode, weather.summary, timeDiff]);

  const dispTemp = (temp) => {
    const indexValue = temp.indexOf('(');
    if (indexValue !== -1) {
      if (typeof Metrics === 'object') {
        if (Array.isArray(Metrics)) {
          if (Metrics[0]?.metric === 'USCS') {
            return temp.slice(indexValue+1, temp?.length-1);
          }
            return temp.slice(0, indexValue-1);
        }
        if (Metrics?.metric === 'USCS') {
          return temp.slice(indexValue+1, temp?.length-1);
        }
          return temp.slice(0, indexValue-1);
      }
    }
    return temp.slice(0, 6);
  };

  return (
    <Col lg={12} className={styles.cardHeight}>
      <Card className={styles.weatherCard} style={{ position: 'relative', height: fullScreenMode ? '100vh' : '' }}>
        <div style={{ position: 'absolute', top: 0, right: '2%' }}>
          {!fullScreenMode && (
            <Clickable onClick={() => { handelFullScreen(true, 2); }}>
              <p style={{ fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', justifyContent: 'flex-end', marginTop: '10PX' }}>
                <FullscreenIcon />
              </p>
            </Clickable>
          )}
          {fullScreenMode && (
            <Clickable onClick={() => { handelFullScreen(false, 2); }}>
              <p style={{ fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', justifyContent: 'flex-end', marginTop: '2%' }}>
                X
              </p>
            </Clickable>
          )}
        </div>
        <div className={styles.spinner}>
          <Spinner large active={loading} />
        </div>
        {weather
          && Object.keys(weather).length > 0 && (
          <>
            <CardTitle>
              <Col lg={12} className="text-center">
                <Row className={styles.weatherRow}>
                  <img src={WeatherIcon} alt="weather" width={60} height={60} />
                  <div className={styles.temperature}>
                    {weather && weather.temperature && dispTemp(weather.temperature)}
                  </div>
                </Row>
                <Row>
                  <Col>
                    <div className={`text-center ${styles.weatherText}`}>
                      {weather && weather.summary && weather.summary.toUpperCase()}
                    </div>
                  </Col>
                </Row>
              </Col>
              <div className={`text-center ${styles.currentweather}`}>Current Weather</div>
            </CardTitle>
            <hr className={styles.hrLine} />
            <CardBody className={styles.airfieldCard}>
              <Fragment>
                <Col>
                  <Row>
                    <Col lg={6} className={styles.firstRow}>
                      <div className={styles.label}>
                        <FormattedMessage
                          id="airfields.weather.relativehumidity"
                          defaultText="Relative Humadity"
                        />
                      </div>
                      <div className={` ${styles.weathervalue}`}>
                        <span dangerouslySetInnerHTML={{ __html: weather && weather.humidity }} />
                      </div>
                    </Col>
                    <Col lg={6} className={styles.firstRow}>
                      <div className={styles.label}>
                        <FormattedMessage
                          id="airfields.weather.wind"
                          defaultText="Wind"
                        />
                      </div>
                      <div className={`${styles.weathervalue}`}>
                        <span dangerouslySetInnerHTML={{ __html: weather && weather.wind }} />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6} className={styles.secondRow}>
                      <div className={styles.label}>
                        <FormattedMessage
                          id="inspections.list.pressure"
                          defaultText="Pressure"
                        />
                      </div>
                      <div className={`${styles.weathervalue}`}>
                        <span dangerouslySetInnerHTML={{ __html: weather && weather.pressure }} />
                      </div>
                    </Col>
                    <Col lg={6} className={styles.secondRow}>
                      <div className={styles.label}>
                        <FormattedMessage
                          id="airfields.weather.dewpoint"
                          defaultText="Dewpoint"
                        />
                      </div>
                      <div className={`${styles.weathervalue}`}>
                        <span dangerouslySetInnerHTML={{ __html: weather && weather.dewpoint }} />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6} className={styles.thirdRow}>
                      <div className={styles.label}>
                        <FormattedMessage
                          id="airfields.weather.visibility"
                          defaultText="Visibility"
                        />
                      </div>
                      <div className={`${styles.weathervalue}`}>
                        <span dangerouslySetInnerHTML={{ __html: weather && weather.visibility }} />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Fragment>
            </CardBody>
          </>
        )
        }
        {
          noWeatherData
          && <div className={styles.weatherInfo}>Currently, there is no weather information for the airport</div>
        }
      </Card>
    </Col>

  );
};

const mapStateToProps = state => ({
  weather: state.airfields.weather
});

const mapDispatchToProps = dispatch => ({
  actionSaveWeather: (data) => {
    dispatch(saveWeatherData(data));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Weather);
